import React, { useEffect, useState } from 'react'
import { HippostdHtml } from '../blog/blogArticle/componentTypes/HippostdHtml.jsx'
import { getMargins } from '../../utility'
import { BrManageContentButton } from '@bloomreach/react-sdk'

const ALIGNMENT = {
  LEFT: 'Left',
  CENTER: 'Center',
}

const HeadlineWrapper = ({ page, component }) => {
  const _parameters = component?.getParameters()
  const parameter = {
    marginTop: _parameters.marginTop || 'No Spacing',
    marginBottom: _parameters.marginBottom || 'No Spacing',
    alignment: _parameters.alignment || ALIGNMENT.LEFT,
    width: _parameters.width || 'inset',
  }

  const _models = component?.getModels() || {}
  const { document: _documentRef } = _models
  const document = _documentRef && page.getContent(_documentRef)
  const data = document?.getData() || {}

  const containerWidth =
    parameter?.width === 'inset'
      ? 'u-sizeConstrained'
      : 'u-sizeFull u-paddingHoriz4gu'
  const italic = data.italicSubHeading ? 'u-textItalic' : ''
  const textAlignment =
    parameter?.alignment === ALIGNMENT.LEFT
      ? 'u-textLeft'
      : parameter?.alignment === ALIGNMENT.CENTER
        ? 'u-textCenter'
        : ''
  const headingMargin =
    data?.heading || data?.subHeading ? 'u-marginBottom2gu' : ''

  return (
    <>
      <div className="u-posRelative">
        {document && <BrManageContentButton content={document} />}
      </div>
      <HeadlineDisplay
        heading={data?.heading}
        subHeading={data?.subHeading}
        content={data?.content?.value}
        containerWidth={containerWidth}
        italic={italic}
        textAlignment={textAlignment}
        headingMargin={headingMargin}
        containerMarginTop={parameter.marginTop}
        containerMarginBottom={parameter.marginBottom}
      />
    </>
  )
}

const HeadlineDisplay = ({
  heading = '',
  subHeading = '',
  content = '',
  containerWidth = '',
  italic = '',
  textAlignment = '',
  headingMargin = '',
  containerMarginTop = '',
  containerMarginBottom = '',
}) => {
  return (
    <div
      className={`Headline ${containerWidth} ${getMargins(containerMarginTop, containerMarginBottom)}`}
    >
      <div className={`${textAlignment} ${headingMargin}`}>
        {heading && (
          <h2 className="u-textColorBrandDark u-textNoTransform u-inline">
            {heading}
          </h2>
        )}
        {heading && subHeading && (
          <h2 className="u-textColorBrandDark u-marginLeft1gu u-marginRight1gu u-inline">
            |
          </h2>
        )}
        {subHeading && (
          <h2
            className={`u-textColorBrandDark u-textNoTransform ${italic} u-inline`}
          >
            {subHeading}
          </h2>
        )}
      </div>
      {content && (
        <HippostdHtml
          value={content}
          classNames={`u-textColorSlateDark ${textAlignment}`}
        />
      )}
    </div>
  )
}

export default HeadlineWrapper
